// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("packs/cookie_consent")

import "modal"
import "bootstrap"
import "../stylesheets/application"
import Plyr from "plyr";

window.Plyr = Plyr;
window.$ = $;

document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
})

document.addEventListener('turbolinks:load', event => {
  if (typeof ga === 'function') {
    ga('set', 'location', event.data.url);
    ga('send', 'pageview');
  }
});

$(document).ready(function() {
  // Init video player
  var player = new Plyr('video', {
    invertTime: false,
    volume: 0.5,
    controls: [
      "play-large",
      "play",
      "progress",
      "current-time",
      "mute",
      "volume",
      "duration"
    ]
  });

  player.on("loadeddata", function(event) {
    player.currentTime = 0;
  });

  // Video tag needs to be removed, otherwise it will keep playing along
  // with new videos which user visits after click the thumbnail.
  //
  $(document).on("click", "a.link", () => {
    if($('#player.video_player').length){
      $('#player.video_player')[0].remove();
    }
  });
});


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Cookie consent popup
window.addEventListener("load", function(){
  window.cookieconsent.initialise({
    "palette": {
      "popup": {
        "background": "#252e39"
      },
      "button": {
        "background": "#14a7d0"
      }
    },
    "theme": "classic",
    "content": {
      "message": "Under the General Data Protection Regulation, cookies are considered personal data. Cookies are used on this website. \
                  We and our partners use cookies to personalize your experience and for measurement and analytics purposes. \
                  By using our website and our services, you agree to our use of cookies as described in our",
      "dismiss": "Got it!",
      "link": "Cookie Policy",
      "href": "http://www.geobeats.com/pages/privacy_policy"
    }
  });
});
